import './App.css';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Copyright from './components/Copyright/Copyright';
import Home from './components/Home/Home';
import Navbar from './components/Navbar/Navbar.js';
import Portfolio from './components/Portfolio/Portfolio';
import Resume from './components/Resume/Resume';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <Portfolio />
      <Resume />
      <About />
      <Contact />
      <Copyright />
    </div>
  );
}

export default App;
